<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  title?: string
  description?: string
  compact?: boolean
}>()
</script>

<template>
  <div
    :class="
      cn(
        'rounded-xl border bg-card text-card-foreground shadow flex flex-col gap-4 pb-4',
        props.class,
      )
    "
  >
    <slot name="header">
      <UiCardHeaderWithActions
        v-if="$slots.actions"
        :class="compact ? 'p-0!' : ''"
      >
        <UiCardTitle v-if="title">
          {{ title }}
        </UiCardTitle>
        <UiCardDescription v-if="description">
          {{ description }}
        </UiCardDescription>
        <template #actions>
          <slot name="actions" />
        </template>
      </UiCardHeaderWithActions>

      <UiCardHeader v-else-if="title || description">
        <UiCardTitle v-if="title">
          {{ title }}
        </UiCardTitle>
        <UiCardDescription v-if="description">
          {{ description }}
        </UiCardDescription>
      </UiCardHeader>
    </slot>
    <slot />
    <slot name="content" />
    <slot name="footer" />
  </div>
</template>
